// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Vuetify
import { createVuetify } from 'vuetify';

const shiftTheme = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    success: '#7aa95a',
    warning: '#ff572d',
    error: '#872335',
  },
};

export default createVuetify({
  theme: {
    defaultTheme: 'shiftTheme',
    themes: {
      shiftTheme,
    },
  },
});
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
